import React, { createContext } from "react";
import useBoxSizes from "../../../utils/customHooks/useBoxSizes";

export const BoxSizeDataContext = createContext(undefined);

const BoxSizeDataProvider = ({ children }) => {
  const [boxSizes, boxSizesPure, selectItemBoxSizes, loading] = useBoxSizes();
  return (
    <BoxSizeDataContext.Provider value={[boxSizes, boxSizesPure, selectItemBoxSizes, loading]}>
      {children}
    </BoxSizeDataContext.Provider>
  );
};
export default BoxSizeDataProvider;
